module.exports = __webpack_public_path__ + "34a6eed15d16d8380fd984425fbaaee7.MP3";